import { WithT } from 'i18next';
import { IPartnerInfoKeysList } from '../models';

export const mapLimitationKeys = (list: IPartnerInfoKeysList, t: WithT['t'] ) => list.map(item => ({
	...item,
	title: item.title ? t(item.title) : t(item.total),
}));
